var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-wrapper",style:({height:_vm.navHeight})},[_c('div',{staticClass:"bar-title",style:({'font-size':_vm.fontSize})},[_vm._v("跨境电商线上综合公共服务平台")])])
}
var staticRenderFns = []

export { render, staticRenderFns }